/** Every word the feedback context's chips say (SA-1304; wireframe decision 14). */

export const CHIP_LABELS = {
  page: 'This page',
  actions: 'Recent steps',
  environment: 'Browser and build',
} as const

export function errorsLabel(count: number): string {
  return count === 1 ? '1 error' : `${count} errors`
}

/** "Attached: this page, 2 errors, recent steps, browser and build"; empty when nothing is. */
export function attachedLine(labels: string[]): string {
  if (labels.length === 0) return ''
  return `Attached: ${labels.map((l) => l.charAt(0).toLowerCase() + l.slice(1)).join(', ')}`
}

export const clickedLine = (name: string) => `Clicked ${name}`
export const changedLine = (field: string) => `Changed ${field}`
export const openedLine = (where: string) => `Opened ${where}`
/** A page-tour event (SA-1315): the tour is a guide's id, the step counted from 1. */
export function tourLine(action: string, tour: string, step?: number): string {
  const n = typeof step === 'number' ? step + 1 : undefined
  if (action === 'start') return `Started the ${tour} tour`
  if (action === 'missing') return n ? `Tour step ${n} was not on the page` : 'A tour step was not on the page'
  if (action === 'exit') return `Left the ${tour} tour`
  if (action === 'done') return `Finished the ${tour} tour`
  return n ? `Tour step ${n}` : `On the ${tour} tour`
}
export const requestsLine = (count: number) =>
  count === 1 ? '1 request to the server' : `${count} requests to the server`

export function apiErrorLine(method: string, path: string, status: number, code?: string): string {
  if (status === 0) return `${method} ${path} did not reach the server`
  return `${method} ${path} answered ${status}${code ? ` ${code}` : ''}`
}

const BROWSERS: Record<string, string> = {
  chrome: 'Chrome',
  edge: 'Edge',
  firefox: 'Firefox',
  safari: 'Safari',
  other: 'Another browser',
}
const PLATFORMS: Record<string, string> = {
  macos: 'macOS',
  windows: 'Windows',
  ios: 'iOS',
  android: 'Android',
  linux: 'Linux',
  other: 'another system',
}

export function browserLine(browser?: string, version?: number, platform?: string): string {
  const name = BROWSERS[browser ?? 'other'] ?? BROWSERS.other
  const on = PLATFORMS[platform ?? 'other'] ?? PLATFORMS.other
  return `${name}${version ? ` ${version}` : ''} on ${on}`
}

export const buildLine = (build: string) => `Build ${build}`
export const screenLine = (w: number, h: number, theme?: string) =>
  `Window ${w} × ${h}${theme ? `, ${theme} theme` : ''}`
export const VIEW_AS_LINE = 'Viewing as another person'
export const featuresLine = (count: number) =>
  count === 1 ? '1 feature enabled' : `${count} features enabled`
